import { Component, OnInit } from '@angular/core';
import { SignInService, StorageService, ViewModeService } from '@services';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { StaticPassAccessConfig } from '@shared/sign-in/sign-in.interface';

@Component({
  selector: 'ft-static-password-access',
  templateUrl: './static-password-access.component.html',
})
export class StaticPasswordAccessComponent
  extends AbstractBaseComponent
  implements OnInit {
  constructor(
    private signInService: SignInService,
    private storageService: StorageService,
    private viewModeService: ViewModeService
  ) {
    super();
    this.isEditMode = this.viewModeService.isEditMode();
  }

  ngOnInit(): void {
    const documentData = this.document?.getData();
    const passConfig: StaticPassAccessConfig = {
      staticPassAccessUsers: documentData?.staticPassAccessUsers || [],
      modalBodyContent: documentData?.modalBodyContent?.value,
      cookieNameSuffix: documentData?.cookieNameSuffix,
    };
    const staticPasswordCookie = this.storageService.staticPassCookieName(
      passConfig?.cookieNameSuffix
    );
    this.storageService
      .retrieve(staticPasswordCookie)
      .then((passwordCookie: string | Int32Array) => {
        const isCookieValid = this.signInService.isStaticPasswordCorrect(
          passConfig.staticPassAccessUsers,
          passwordCookie
        );
        if (!passwordCookie || !isCookieValid) {
          this.signInService.setStaticPassAccessConfig(passConfig);
        }
      });
  }
}
